import SvgIcon from "@mui/material/SvgIcon";

interface InputsOutputsIconProps {
  htmlColor?: string;
  fontSize?: "small" | "inherit" | "large" | "medium";
}

export default function InputsOutputsIcon({
  htmlColor,
  fontSize = "medium",
}: InputsOutputsIconProps) {
  return (
    <SvgIcon viewBox="0 0 14 14" fontSize={fontSize}>
      <g clipPath="url(#clip0_487_2842)">
        <path
          d="M5.77032 9.56567C5.53043 9.56567 5.33594 9.76017 5.33594 10.0001V11.0396C5.33594 11.2795 5.53043 11.474 5.77032 11.474C6.01021 11.474 6.2047 11.2795 6.2047 11.0396V10.0001C6.20473 9.76017 6.01023 9.56567 5.77032 9.56567Z"
          fill={htmlColor || "currentColor"}
        />
        <path
          d="M8.22735 9.56567C7.98747 9.56567 7.79297 9.76017 7.79297 10.0001V11.0396C7.79297 11.2795 7.98747 11.474 8.22735 11.474C8.46724 11.474 8.66173 11.2795 8.66173 11.0396V10.0001C8.66176 9.76017 8.46727 9.56567 8.22735 9.56567Z"
          fill={htmlColor || "currentColor"}
        />
        <path
          d="M13.9941 4.20642C13.9941 3.96653 13.7996 3.77203 13.5598 3.77203H10.7695C10.5762 3.42408 10.3334 3.10091 10.0441 2.81167C10.0338 2.80136 10.0233 2.79151 10.0129 2.78131V1.21252C10.0129 0.972633 9.81839 0.778137 9.57851 0.778137C9.33862 0.778137 9.14412 0.972633 9.14412 1.21252V2.11951C7.80223 1.34604 6.15272 1.37128 4.84416 2.11634V1.21252C4.84416 0.972633 4.64966 0.778137 4.40977 0.778137C4.16989 0.778137 3.97539 0.972633 3.97539 1.21252V2.7727C3.67346 3.06946 3.41968 3.40891 3.21969 3.77209H0.428523C0.188637 3.77206 -0.00585938 3.96656 -0.00585938 4.20644C-0.00585938 5.5858 1.3835 6.54822 2.68064 6.04635V8.20383C2.01807 8.63624 1.61642 9.36845 1.61642 10.174V10.8751C1.61642 12.1739 2.67301 13.2305 3.97181 13.2305H10.0165C11.3153 13.2305 12.3719 12.1739 12.3719 10.8751V10.174C12.3719 9.36837 11.9701 8.6361 11.3077 8.2038V6.04635C12.606 6.54865 13.9941 5.58408 13.9941 4.20642ZM3.5494 5.8617C3.5494 5.84879 3.5497 5.83588 3.54984 5.82298C3.54984 4.02249 5.10886 2.41484 7.22938 2.41484C9.14412 2.41484 10.4389 4.23729 10.4389 5.8617V7.8561C9.94038 7.76603 3.76028 7.81787 3.5494 7.8561V5.8617ZM0.95191 4.6408H2.85602C2.82597 4.74293 2.79791 4.85359 2.77555 4.95856C2.23365 5.54232 1.26716 5.37501 0.95191 4.6408ZM11.5031 10.174V10.8751C11.5031 11.6948 10.8362 12.3617 10.0165 12.3617H3.97178C3.15204 12.3617 2.48516 11.6949 2.48516 10.8751V10.174C2.48516 9.339 3.16137 8.68737 3.97178 8.68737H10.0165C10.8253 8.6874 11.5031 9.33753 11.5031 10.174ZM11.2133 4.95913C11.1906 4.85181 11.1638 4.74561 11.133 4.6408H13.0364C12.7209 5.37566 11.7547 5.54161 11.2133 4.95913Z"
          fill={htmlColor || "currentColor"}
        />
        <path
          d="M4.92424 7.15396C5.2416 7.15396 5.49887 6.89669 5.49887 6.57933C5.49887 6.26197 5.2416 6.0047 4.92424 6.0047C4.60688 6.0047 4.34961 6.26197 4.34961 6.57933C4.34961 6.89669 4.60688 7.15396 4.92424 7.15396Z"
          fill={htmlColor || "currentColor"}
        />
        <path
          d="M9.09221 7.15179C9.40957 7.15179 9.66684 6.89452 9.66684 6.57716C9.66684 6.2598 9.40957 6.00253 9.09221 6.00253C8.77485 6.00253 8.51758 6.2598 8.51758 6.57716C8.51758 6.89452 8.77485 7.15179 9.09221 7.15179Z"
          fill={htmlColor || "currentColor"}
        />
      </g>
      <defs>
        <clipPath id="clip0_487_2842">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
